import Plyr from 'plyr'
import Hls from 'hls.js'

function init() {
    const video = document.getElementById('protected-video-player')
    if (!video) {
        return
    }

    const source = video.querySelector('source')
    const src = source ? source.getAttribute('src') : null
    if (!src) {
        return
    }

    const plyrOptions = {
        controls: [
            'play-large',
            'play',
            'progress',
            'current-time',
            'duration',
            'mute',
            'volume',
            'settings',
            'fullscreen',
        ],
        settings: ['speed'],
        tooltips: { controls: true, seek: true },
        fullscreen: {
            iosNative: true,
        },
        i18n: {
            restart: 'Újraindítás',
            rewind: 'Vissza {seektime} másodpercet',
            play: 'Lejátszás',
            pause: 'Szünet',
            fastForward: 'Előre {seektime} másodpercet',
            seek: 'Tekerés',
            played: 'Lejátszva',
            buffered: 'Pufferelve',
            currentTime: 'Aktuális idő',
            duration: 'Teljes hossz',
            volume: 'Hangerő',
            mute: 'Némítás',
            unmute: 'Némítás feloldása',
            download: 'Letöltés',
            enterFullscreen: 'Teljes képernyő',
            exitFullscreen: 'Kilépés a teljes képernyőből',
            settings: 'Beállítások',
            menuBack: 'Vissza',
            speed: 'Sebesség',
            normal: 'Normál',
            quality: 'Minőség',
            loop: 'Ismétlés',
        },
    }

    if (Hls.isSupported()) {
        if (source) {
            source.remove()
        }

        const hls = new Hls()
        hls.loadSource(src)
        hls.attachMedia(video)

        new Plyr(video, plyrOptions)
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        new Plyr(video, plyrOptions)
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
} else {
    init()
}
